import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { updateTranslationsAfterAPI } from "../../i18n";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getTranslations } from "slices/thunks";
import { AnyAction, ThunkDispatch } from "@reduxjs/toolkit";
import languages from "common/languages";
import { getLanguageCodeForTranslation } from "helpers/languageHelper";
import LightDark from "Components/Common/LightDark";
import { RiLogoutBoxLine } from "react-icons/ri";

const SidebarMenuItem = ({ subItems, isAccountMenu, handleClick }: any) => {
  const currentLanguage: any = sessionStorage.getItem("I18N_LANGUAGE");

  const [selectedLang, setSelectedLang] = useState<string>(
    currentLanguage || ""
  );
  const [darkMode, setDarkMode] = useState(false);
  const [layoutMode, setLayoutMode] = useState("light");

  const { t } = useTranslation();
  const dispatch = useDispatch<ThunkDispatch<any, any, AnyAction>>();

  const translationsState = useSelector((state: any) => state.Translation);
  const { authData } = useSelector((state: any) => state.Dashboard);

  useEffect(() => {
    if (!currentLanguage && authData && authData.culture) {
      const languageCode = getLanguageCodeForTranslation(authData.culture);
      sessionStorage.setItem("I18N_LANGUAGE", languageCode);
      setSelectedLang(languageCode);
      dispatch(getTranslations(languageCode));
    }
  }, [authData.culture]);

  useEffect(() => {
    if (translationsState.translations && selectedLang) {
      updateTranslationsAfterAPI(translationsState.translations, selectedLang);
    }
  }, [translationsState.translations, selectedLang]);

  const changeLanguageAction = (lang: string) => {
    sessionStorage.setItem("I18N_LANGUAGE", lang);
    setSelectedLang(lang);
    dispatch(getTranslations(lang));
    // window.location.reload();
  };

  const handleLogout = () => {
    sessionStorage.removeItem("I18N_LANGUAGE");
    sessionStorage.removeItem("authUser");
    localStorage.removeItem("authData");
    window.location.reload();
  };

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  const onChangeLayoutMode = (newMode: string) => {
    setLayoutMode(newMode);
  };

  return (
    <>
      {!isAccountMenu ? (
        subItems.map((subItem: any, key: any) => (
          <li
            className="nav-item sidebar-menu-item"
            key={`sidebar-menu-item-${subItem.label}@${key}`}
            onClick={!subItem.external ? handleClick : undefined}
          >
            {subItem.external ? (
              <a
                href={subItem.link}
                target="_blank"
                rel="noopener noreferrer"
                className="selected"
              >
                {subItem.label}
                {subItem.badgeName && (
                  <span
                    className={`badge badge-pill bg-${subItem.badgeColor}`}
                    data-key="t-new"
                  >
                    {subItem.badgeName}
                  </span>
                )}
              </a>
            ) : (
              <Link
                to={subItem.link ? subItem.link : "/#"}
                className="selected"
              >
                {subItem.label}
                {subItem.badgeName && (
                  <span
                    className={`badge badge-pill bg-${subItem.badgeColor}`}
                    data-key="t-new"
                  >
                    {subItem.badgeName}
                  </span>
                )}
              </Link>
            )}
          </li>
        ))
      ) : (
        <>
          {subItems.map((subItem: any, key: any) => (
            <li
              className="nav-item sidebar-menu-item"
              key={`sidebar-menu-item-${subItem.label}@${key}`}
              onClick={handleClick}
            >
              <Link
                to={subItem.link ? subItem.link : "/#"}
                className="selected"
              >
                {subItem.label}
                {subItem.badgeName && (
                  <span
                    className={`badge badge-pill bg-${subItem.badgeColor}`}
                    data-key="t-new"
                  >
                    {subItem.badgeName}
                  </span>
                )}
              </Link>
            </li>
          ))}

          <li className="nav-item sidebar-menu-item mt-5">
            <h3 className="sidebar-sub-menu-title mt-5">{t("language")}</h3>
            <ul className="language-menu">
              {languages.map((language, index) => (
                <li
                  key={`language-menu-${language.languageTitle}@${index}`}
                  className={
                    language.languageCode == selectedLang ? "active" : "none"
                  }
                  onClick={() => changeLanguageAction(language.languageCode)}
                >
                  <span>{language.languageTitle}</span>
                </li>
              ))}
            </ul>

            {/* <label htmlFor="toggleButton" className="switch theme-toggle mt-5">
              <input
                type="checkbox"
                name="toggleButton"
                id="toggleButton"
                checked={darkMode}
                onChange={toggleDarkMode}
              />
              <div className="switch-button">
                <span></span>
              </div>
              <span className="text">Dark Mode</span>
            </label> 
            */}

            {/* <LightDark
              layoutMode={layoutMode}
              onChangeLayoutMode={onChangeLayoutMode}
            /> */}

            <hr className="d-none d-lg-block mt-3" />

            <div className="logout d-none d-lg-block mt-3">
              <div
                className="d-flex align-items-center cursor-pointer gap-2"
                onClick={handleLogout}
              >
                <RiLogoutBoxLine size={23} />
                <span className="text">{t("logout")}</span>
              </div>
            </div>
          </li>
        </>
      )}
    </>
  );
};

export default SidebarMenuItem;
